import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 18v-12h4a4 4 0 0 1 4 4v4","key":"svg-0"}],["path",{"d":"M18 6v12h-4a4 4 0 0 1 -4 -4v-4","key":"svg-1"}]]

/**
 * IconCurrencyShekel
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktc2hla2VsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik02IDE4di0xMmg0YTQgNCAwIDAgMSA0IDR2NCIgLz4KICA8cGF0aCBkPSJNMTggNnYxMmgtNGE0IDQgMCAwIDEgLTQgLTR2LTQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/currency-shekel
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyShekel = createReactComponent('outline', 'currency-shekel', 'CurrencyShekel', __iconNode);

export default IconCurrencyShekel;